import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const DASHBOARD_BASE_URL = `${API_URL}/system-info`;

export const getDashboardDetail = createAsyncThunk(
  "dashboard",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(DASHBOARD_BASE_URL);
      return data;
    } catch (error: any) {
      const msg = error?.response?.data?.responseMessage || error.message;
      notify(msg, "error");
      return rejectWithValue(msg);
    }
  }
);
